import { MargoURLs } from "LibMargoWorld/micc";

function parseWater(water: string) {
    if (!water) return [];

    const spl = water.split("|");
    const res = [];

    for (const entry of spl) {
        const ww = entry.split(",").map(parseInt);
        for (let j = 1 * ww[0]; j <= 1 * ww[1]; ++j) {
            res[j + 256 * ww[2]] = 4 * ww[3];
        }
    }

    return res;
}

function initWorldFrame(focus: string, waterData: string) {
    try {
        if (focus) {
            const focusEl = document.querySelector(`#${focus}`);
            if (focusEl && focusEl instanceof HTMLElement) {
                const s = document.scrollingElement;
                s.scrollLeft = focusEl.offsetLeft - s.clientWidth / 2;
                s.scrollTop = focusEl.offsetTop - s.clientHeight / 2;
            }
        }
    } catch (e) {
        console.warn(e);
    }

    const water = parseWater(waterData);
    const objects = document.querySelectorAll(".object.npc");
    for (const obj of Array.from(objects)) {
        if (!(obj instanceof HTMLElement)) continue;

        const img = new Image();
        const clb = () => {
            const imgX = img.width;
            const imgY = img.height;

            const x = parseInt(obj.dataset.x);
            const y = parseInt(obj.dataset.y);

            // Adapted from SI code (what kinda garbage)
            const tmpLeft = x * 32 + 16 - Math.round(imgX / 2) + (parseInt(obj.dataset.type) > 3 && !(imgX % 64) ? -16 : 0);
            const wpos = x + y * 256;
            let wat = water[wpos] ? water[wpos] / 4 : 0;

            const destinationX = tmpLeft;
            const destinationY = y * 32 + 32 - imgY;
            const h = imgY - (wat > 8 ? (wat - 8) * 4 : 0);
            obj.style.left = `${destinationX}px`;
            obj.style.top = `${destinationY}px`;
            obj.style.width = `${imgX}px`;
            obj.style.height = `${h}px`;
            obj.style.background = `url(${MargoURLs.npcPath}${obj.dataset.icon})`;

            if (obj.dataset.type == "4") {
                obj.style.pointerEvents = "none";
            }
        };
        img.addEventListener("load", clb);
        img.src = MargoURLs.npcPath + obj.dataset.icon;
    }
}

export function initWorld() {
    // Page scrolling
    const scrollData = {
        top: 0,
        left: 0,
        x: 0,
        y: 0,
    };
    const mouseup = (_e: MouseEvent) => {
        document.scrollingElement.removeEventListener("mouseup", mouseup);
        document.scrollingElement.removeEventListener("mousemove", mousemove);
    };
    const mousemove = (e: MouseEvent) => {
        const dx = e.clientX - scrollData.x;
        const dy = e.clientY - scrollData.y;

        document.scrollingElement.scrollTop = scrollData.top - dy;
        document.scrollingElement.scrollLeft = scrollData.left - dx;
    };
    const mousedown = (e: MouseEvent) => {
        document.scrollingElement.addEventListener("mouseup", mouseup);
        document.scrollingElement.addEventListener("mousemove", mousemove);
        scrollData.left = document.scrollingElement.scrollLeft;
        scrollData.top = document.scrollingElement.scrollTop;
        scrollData.x = e.clientX;
        scrollData.y = e.clientY;
    };

    document.scrollingElement.addEventListener("mousedown", mousedown);

    // @ts-ignore
    window.initWorldFrame = initWorldFrame;
}
